import { Avatar, Icon, Menu } from 'antd';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import tamgiac from './../../resources/assets/images/tamgiac.png';
import './styles.css';
import { confirmChangeItem } from './../../services/dialog'
import lang from './../../languages/en'
import history from './../../services/history'
import { alertError } from './../../services/dialog'
import handlePermission from '../../containers/app/handlePermission';
import { permissions } from '../../constants';

class SettingMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: '',
        }
    }
    componentDidMount() {
        let url = window.location.href
        let arr = url.split('/')

        let selected = arr.pop()
        this.setState({
            selected,
        })
    }

    handleEditItemMaster = (e, url) => {
        if(this.props.checkErrorInput) {
            e.preventDefault()
            return alertError(lang.field_some_required)
        }
        if(this.props.editItemMaster) {
            e.preventDefault()
            confirmChangeItem(lang.confirm_save_item_name, async () => {
                await this.props.saveItemMaster()
                await history.push(url)
            }, () => {
                history.push(url)
            })
        }
    }

    render() {
        const { selected } = this.state
        return (
            <div className="menu">
                <Menu mode="inline" style={{ height: '600px', borderRight: 0 }}>
                    {
                        handlePermission(permissions.EcCredentialSaveSetting) ?  
                            <Menu.Item key="2" className={selected === 'channel' ? 'active' : 'not-active'}>
                                <Link 
                                    onClick={(e) => this.handleEditItemMaster(e, "/setting/channel")} 
                                    to="/setting/channel" 
                                    className='block-link-when-not-save-item'
                                >
                                    <Icon type="shopping-cart" style={{ fontSize: '38px', color: '#333333' }} />
                                    <h5>E-Commerce Channels</h5>
                                    {selected === 'channel' && <img src={tamgiac} className="show" />}
                                </Link>
                            </Menu.Item>
                        : ""
                    }
                    
                    {   
                         handlePermission(permissions.ItemNameSearchAll) ? 
                            <Menu.Item key="1" className={selected === 'merchant' ? 'active' : 'not-active'}>
                                <Link 
                                    onClick={(e) => this.handleEditItemMaster(e, "/setting/merchant")} 
                                    to="/setting/merchant" 
                                    className='block-link-when-not-save-item'
                                >
                                    <Icon type="tag" style={{ fontSize: '38px', color: '#333333' }} />
                                    <h5>Global Merchant Settings</h5>
                                    {selected === 'merchant' && <img src={tamgiac} className="show" />}
                                </Link>
                            </Menu.Item> 
                        : ""
                    }
                    
                    {
                        handlePermission(permissions.PrinterSavePrinterSetting) ? 
                            <Menu.Item key="3" className={selected === 'printer' ? 'active' : 'not-active'}>
                                <Link 
                                    onClick={(e) => this.handleEditItemMaster(e, "/setting/printer")} 
                                    to="/setting/printer" 
                                    className='block-link-when-not-save-item'
                                >
                                    <Icon type="printer" style={{ fontSize: '38px', color: '#333333' }} />
                                    <h5>Printers</h5>
                                    {selected === 'printer' && <img src={tamgiac} className="show" />}
                                </Link>
                            </Menu.Item>
                        : ""
                    } 

                    {
                        handlePermission(permissions.UserUpdate) ? 
                        <Menu.Item key="4" className={selected === 'account' ? 'active' : 'not-active'}>
                            <Link 
                                onClick={(e) => this.handleEditItemMaster(e, "/setting/account")} 
                                to="/setting/account" 
                                className='block-link-when-not-save-item'
                            >
                                <Avatar size="middle" icon="user" style={{ fontSize: '25px', color: '#333333' }} />
                                <h5>My Account</h5>
                                {selected === 'account' && <img src={tamgiac} className="show" />}
                            </Link>
                        </Menu.Item>
                        : ""
                    }

                    {
                        handlePermission(permissions.UserUpdate) ? 
                            <Menu.Item key="5" className={selected === 'mfa' ? 'active' : 'not-active'}>
                                <Link 
                                    onClick={(e) => this.handleEditItemMaster(e, "/setting/mfa")} 
                                    to="/setting/mfa" 
                                    className='block-link-when-not-save-item'
                                >
                                    <Icon type="safety" style={{ fontSize: '38px', color: '#333333' }} />
                                    <h5>Two-Factor Authentication</h5>
                                    {selected === 'mfa' && <img src={tamgiac} className="show" />}
                                </Link>
                            </Menu.Item>
                        : ""
                    }
                </Menu>
            </div>
        )
    }
}

export default SettingMenu



// WEBPACK FOOTER //
// ./src/components/sidebar-setting/index.js